import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import PromiseContainer from '../../../components/data/PromiseContainer';
import { Page } from '../../../components/surfaces';
import { useStore } from '../../../store';
import usePromise from '../../../store/utils/usePromise';
import BundleForm from './components/BundleForm';

export default observer(function EditBundlePage() {
  const { bundleStore, productStore } = useStore();

  const [bundle] = useState(() => bundleStore.createBundle());
  const [productsPromise] = usePromise(() => productStore.fetchAllProducts());

  return (
    <Page navigation={bundle.displayName || 'New bundle'}>
      <PromiseContainer promise={productsPromise}>
        {(value) => <BundleForm bundle={bundle} products={value} />}
      </PromiseContainer>
    </Page>
  );
});
